module.exports = __webpack_public_path__ + "img/风险处置-bg.4a0957c6.jpg";